import React from 'react';
import { MessageSchema, AttachedMsg } from '../types';
import { EmptyMessage } from './EmptyMessage';
import style from '../message.module.scss';
import { Content } from '../../../../chat/pages/content/types';
import { SetState } from '../../../../chat/types';
import { ReactSortable } from 'react-sortablejs';
import { PreviewContent } from './PreviewContent';
import { labelMap } from './AddMessagePanel';

export const sortableOptions = {
	animation: 150,
	fallbackOnBody: true,
	swapThreshold: 0.65,
	ghostClass: 'ghost',
	group: 'shared',
	disabled: false,
	handle: '.drag-handle',
};

type Props = {
	lock: boolean;
	message: MessageSchema;
	viewPanel: (visibility: boolean) => void;
	contents: Content[];
	removeAction: (index: number) => void;
	setEditAction: SetState<any>;
	setList: (data: AttachedMsg[]) => void;
};

export function OnEnter(props: Props) {
	const {
		message,
		viewPanel,
		contents,
		removeAction,
		setEditAction,
		lock,
		setList,
	} = props;
	const onEnter = message.onEnter;

	return (
		<>
			{onEnter.length ? (
				<ReactSortable
					list={onEnter as any}
					setList={setList as any}
					className={style.list}
					{...sortableOptions}
				>
					{onEnter
						.map((msg, index) => {
							return <PreviewContent
							  contents={contents}
								lock={lock}
								index={index}
								setEditAction={setEditAction}
								removeAction={removeAction}
								key={msg._id}
								msg={msg}
							/>
						})}
				</ReactSortable>
			) : (
				<EmptyMessage lock={lock} onAdd={() => viewPanel(true)} />
			)}
		</>
	);
}
